// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@guestsupply/App/Components/Notify";
import Search2 from "@guestsupply/XDL/Icons/Search2";
import { mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { changeCustomerSelectCustomerContainerStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { css } from "styled-components";

changeCustomerSelectCustomerContainerStyles.cancelButton = {
    variant: "tertiary",
    css: css`
        margin-right: 15px;
        margin-top: 4px;
    `,
};

changeCustomerSelectCustomerContainerStyles.continueButton = {
    css: css`
        margin-top: 4px;
    `,
};

changeCustomerSelectCustomerContainerStyles.useDefaultCustomerDescriptionHidden = {
    css: css`
        display: none;
    `,
};

changeCustomerSelectCustomerContainerStyles.useDefaultCustomerDescriptionVisible = {
    css: css`
        margin-top: 12px;
        font-size: 12px;
        line-height: 13px;
    `,
};

changeCustomerSelectCustomerContainerStyles.fulfillmentMethodSelectorGridItem = {
    width: 12,
    css: css`
        &:empty {
            display: none;
        }
    `,
};

changeCustomerSelectCustomerContainerStyles.container = {
    gap: 16,
    css: css`
        width: 656px;

        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

changeCustomerSelectCustomerContainerStyles.buttonsGridItem = {
    width: 12,
};

changeCustomerSelectCustomerContainerStyles.useDefaultCustomerDescriptionVisible = {
    ...mergeWithCss(getNotifyStyle("info"), {
        css: css`
            margin-top: 20px;
            margin-bottom: 0;
        `,
    }),
};

changeCustomerSelectCustomerContainerStyles.billToSelector = {
    billToSelectorDynamicDropdown: {
        preIconProps: {
            src: Search2,
        },
    } as any
}

changeCustomerSelectCustomerContainerStyles.shipToSelector = {
    shipToSelectorDynamicDropdown: {
        preIconProps: {
            src: Search2,
        },
    } as any
}